import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import { ServiceUrlTypeDict } from "../CreateUrlUtils";

// ----------------------------------------------------------------------

export const CardHeader = () => {
	const { state } = useContext(Context);
	const { translate } = useLocales();
	return (
		<Stack gap={0.5}>
			<Typography variant='h6'>{"Crea una URL"}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate(ServiceUrlTypeDict[state.type]?.description)}
			</Typography>
		</Stack>
	);
};

export default CardHeader;
